<template>
  <div
    v-if="profile.title || profile.image_url || profile.name || profile.email"
    class="mb-8"
  >
    <h2
      v-if="profile.title"
      data-qa="ceo-contact-title"
      class="text-h6 text--text mt-0"
      :class="isMobile ? 'mb-4' : 'mb-3'"
    >
      {{ transDynamic(profile, `title,${language},${needTranslate}`) }}
    </h2>

    <div
      class="d-flex align-center mb-3"
      :class="isMobile ? 'mb-4' : 'mb-3'"
    >
      <img
        v-if="profile.image_url"
        data-qa="ceo-contact-image"
        :src="profile.image_url"
        :alt="transDynamic(profile, `name,${language},${needTranslate}`)"
        width="40"
        height="40"
        class="mr-3"
      >

      <div>
        <div
          v-if="profile.name"
          data-qa="ceo-contact-name"
          class="text-body-1 text--text"
        >
          {{ transDynamic(profile, `name,${language},${needTranslate}`) }}
        </div>

        <a
          v-if="profile.email"
          data-qa="ceo-contact-email"
          class="text-body-1 d-inline-flex link-decoration-none primary--text"
          :href="`mailto:${profile.email}`"
        >{{ profile.email }}</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/components/pages/info/contacts/types'
import { useContextStore } from 'src/store'
import transDynamic from 'djanjucks/filters/transDynamic'

const { context }: ContextStore = useContextStore()

const { language } = I18NextVue
const needTranslate = context.feature_flags.pd_l10n_footer_pages

const isMobile = computed(() => context?.flavour === 'mobile')

defineProps<{
  profile: ContextStore['context']['company_ceo_contacts'][number]
}>()
</script>
